// import { serializeQuery } from 'helpers/urlTools';
import clearStorages from 'helpers/clearStorages';
import SessionStorage from 'libs/SessionStorage';
import OidcService from 'services/OidcService';
import App from 'modules/App';
import Account from 'modules/Account';
const validateAccount = (route, state, getUrl)=>{
    const activeProfileMainUrlRoute = Account.selectors.activeProfileMainUrlRoute(state);
    if (activeProfileMainUrlRoute.isFinal) {
        return null;
    }
    const { name, params, alternates } = activeProfileMainUrlRoute;
    if (name === route.name || alternates && alternates.includes(route.name)) {
        return null;
    }
    return getUrl(name, params);
};
// TODO: Move to getMe (?)
const validateSensitiveDataAccessAlert = (cookies, store)=>{
    const state = store.getState();
    const wasAlertDisplayed = cookies.get('sensitive-data-access-alert-displayed');
    if (wasAlertDisplayed) {
        return;
    }
    const countryId = Account.selectors.countryId(state);
    const countries = App.selectors.countries(state);
    const country = countries.find((c)=>c.countryId === countryId);
    if (country.alpha2Code !== 'es') {
        return;
    }
    // @ts-expect-error: Incorrect Alert type recognition from js
    store.dispatch(App.actions.setAlert({
        type: 'warning',
        message: Account.messages.alerts.sensitiveDataAccess
    }));
    cookies.set('sensitive-data-access-alert-displayed', true, {
        path: '/',
        expires: new Date('2040-12-31')
    });
};
//----------------------------------------------------------------------------------------------------------------------
function delay(time) {
    return new Promise((resolve)=>{
        setTimeout(resolve, time);
    });
}
export const loggedInGuard = async ({ fullPath })=>{
    const token = await OidcService.getToken();
    if (!token) {
        clearStorages(true);
        SessionStorage.setItem('returnPathname', fullPath);
        await OidcService.login();
        await delay(2000);
    }
    // const state = store.getState();
    // const isAuthenticated = Account.selectors.isAuthenticated(state);
    // if (!isAuthenticated) {
    //   store.dispatch(Account.actions.clearSession());
    //   let returnPathname = '';
    //   if (pathname) {
    //     returnPathname += pathname;
    //     if (query) returnPathname += `?${serializeQuery(query)}`;
    //     returnPathname = encodeURIComponent(returnPathname);
    //   }
    //   return `${getUrl('sign-in')}${returnPathname && `?returnPathname=${returnPathname}`}`;
    // }
    return null;
};
//----------------------------------------------------------------------------------------------------------------------
export const caregiverOrPatientGuard = async (context)=>{
    const redirect = await loggedInGuard(context);
    if (redirect) {
        return redirect;
    }
    const { route, store, getUrl } = context;
    const state = store.getState();
    const isCareGiver = Account.selectors.isCareGiver(state);
    const isPatient = Account.selectors.isPatient(state);
    if (!isCareGiver && !isPatient) {
        const hcpProfileMainUrlRoute = Account.selectors.hcpProfileMainUrlRoute(state);
        const redirectUrl = getUrl(hcpProfileMainUrlRoute.name, hcpProfileMainUrlRoute.params);
        if (redirectUrl) {
            return redirectUrl;
        }
    }
    return validateAccount(route, state, getUrl);
};
export const patientGuard = async (context)=>{
    const redirect = await loggedInGuard(context);
    if (redirect) {
        return redirect;
    }
    const { route, store, getUrl } = context;
    const state = store.getState();
    const isPatient = Account.selectors.isPatient(state);
    if (!isPatient) {
        const hcpProfileMainUrlRoute = Account.selectors.hcpProfileMainUrlRoute(state);
        const redirectUrl = getUrl(hcpProfileMainUrlRoute.name, hcpProfileMainUrlRoute.params);
        if (redirectUrl) {
            return redirectUrl;
        }
    }
    store.dispatch(Account.actions.setActiveProfileType(Account.constants.PROFILE_TYPES.PWD));
    return validateAccount(route, state, getUrl);
};
export const professionalGuard = async (context)=>{
    const redirect = await loggedInGuard(context);
    if (redirect) {
        return redirect;
    }
    const { route, cookies, store, getUrl } = context;
    const state = store.getState();
    const isHcp = Account.selectors.isHcp(state);
    if (!isHcp) {
        const patientProfileMainUrlRoute = Account.selectors.patientProfileMainUrlRoute(state);
        const redirectUrl = getUrl(patientProfileMainUrlRoute.name, patientProfileMainUrlRoute.params);
        if (redirectUrl) {
            return redirectUrl;
        }
    }
    validateSensitiveDataAccessAlert(cookies, store);
    return validateAccount(route, state, getUrl);
};
//----------------------------------------------------------------------------------------------------------------------
export const clinicMembershipGuard = async (context, params)=>{
    const redirect = await professionalGuard(context);
    if (redirect) {
        return redirect;
    }
    const { store, getUrl } = context;
    const { clinicSlug, organizationUID } = params;
    const state = store.getState();
    const { activeOrganizationUID, hcpProfile } = state.account;
    const { organizationMemberships = [] } = state.information;
    const clinicHcpMemberships = hcpProfile && hcpProfile.clinicHcpMemberships ? hcpProfile.clinicHcpMemberships : [];
    const clinicMembership = clinicHcpMemberships.find((cm)=>cm.clinic.organizationUID === organizationUID);
    const organizationMembership = organizationMemberships.find((om)=>om.organization.organizationUID === organizationUID);
    if (!clinicMembership && !organizationMembership) {
        return getUrl('error', {
            code: 404
        });
    //   const redirect = hcpGuard(context);
    //   if (redirect) {
    //     return redirect;
    //   }
    }
    const isClientInitialized = App.selectors.isClientInitialized(state);
    const clinicHcpMembershipId = clinicMembership && clinicMembership.clinicHcpMembershipId;
    if (process.env.BROWSER && !isClientInitialized || activeOrganizationUID !== organizationUID) {
        store.dispatch(Account.actions.setActiveClinicMembershipId(clinicHcpMembershipId, organizationUID));
    }
    if (clinicMembership && clinicMembership.clinic.clinicStatus === 'Deleted') {
        if (clinicMembership.isAdmin) {
            return getUrl('clinic-clear-data', {
                clinicSlug,
                organizationUID
            });
        }
    }
    return null;
};
export const adminClinicMembershipGuard = async (context, params)=>{
    const redirect = await professionalGuard(context);
    if (redirect) {
        return redirect;
    }
    const { store, getUrl } = context;
    const { organizationUID } = params;
    const state = store.getState();
    const { activeClinicMembershipId, activeHcpInvitationId, hcpProfile } = state.account;
    let clinicMembership;
    if (hcpProfile) {
        clinicMembership = hcpProfile.clinicHcpMemberships.find((cm)=>cm.clinic.organizationUID === organizationUID && cm.isAdmin && cm.membershipStatus === 'Active' && cm.clinic && [
                'Active',
                'Deleted'
            ].includes(cm.clinic.clinicStatus));
    }
    if (!clinicMembership) {
        return getUrl('error', {
            code: 404
        });
    }
    const isClientInitialized = App.selectors.isClientInitialized(state);
    if (process.env.BROWSER && !isClientInitialized || activeClinicMembershipId !== clinicMembership.clinicHcpMembershipId || activeHcpInvitationId) {
        store.dispatch(Account.actions.setActiveClinicMembershipId(clinicMembership.clinicHcpMembershipId, organizationUID));
    }
    return null;
};
export const adminActiveClinicMembershipGuard = async (context)=>{
    const redirect = await professionalGuard(context);
    if (redirect) {
        return redirect;
    }
    const { store, getUrl } = context;
    const state = store.getState();
    const isClinicAdmin = Account.selectors.isClinicAdmin(state);
    if (!isClinicAdmin) {
        const activeProfileMainUrlRoute = Account.selectors.activeProfileMainUrlRoute(state);
        return getUrl(activeProfileMainUrlRoute.name, activeProfileMainUrlRoute.params);
    }
    return null;
};
export const deletedClinicGuard = async (context, params)=>{
    const redirect = await professionalGuard(context);
    if (redirect) {
        return redirect;
    }
    const { store, getUrl } = context;
    const { clinicSlug, organizationUID } = params;
    const state = store.getState();
    const { activeClinicMembershipId, activeHcpInvitationId, hcpProfile } = state.account;
    let clinicMembership;
    if (hcpProfile) {
        clinicMembership = hcpProfile.clinicHcpMemberships.find((cm)=>cm.clinic.organizationUID === organizationUID);
    }
    if (!clinicMembership) {
        return getUrl('error', {
            code: 404
        });
    }
    if (!clinicMembership.isAdmin || clinicMembership.clinic.clinicStatus !== 'Deleted') {
        return getUrl('general-population', {
            clinicSlug,
            organizationUID
        });
    }
    const isClientInitialized = App.selectors.isClientInitialized(state);
    if (process.env.BROWSER && !isClientInitialized || activeClinicMembershipId !== clinicMembership.clinicHcpMembershipId || activeHcpInvitationId) {
        store.dispatch(Account.actions.setActiveClinicMembershipId(clinicMembership.clinicHcpMembershipId, organizationUID));
    }
    return null;
};
